<template>
  <div class="iv-review-group">
    <section class="iv-main-width iv-p-t-40 iv-review-top iv-p-b-40">
      <Expand :defaultExpand="true">
        <h1 class="iv-fs-24 iv-fc-85" slot="title">
          {{reviewInfo.title}}
        </h1>
        <p class="iv-m-t-12 iv-fs-16 iv-fc-65">发布评审：{{reviewInfo.publishOrg}}</p>
        <Row class="iv-m-t-12">
          <Col :span="8" class="iv-fs-16 iv-fc-65">发布人：{{reviewInfo.publisher}}</Col>
          <!-- <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)邮箱：{{reviewInfo.email}}</Col>
          <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)联系方式：{{reviewInfo.phone}}</Col> -->
        </Row>
      </Expand>
    </section>
    <div class="iv-p-t-40 iv-review-content">
      <div class="iv-main-width">
        <section>
          <Expand :defaultExpand="true">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-36" slot="title">评审组</h1>
            <DragTable
              ref="DragTable"
              :showPage="false"
              noSearch
              :showSelect="false"
              :immediateForce="true"
              :columns="columns"
              :tableData="tableData">
            </DragTable>
          </Expand>
        </section>
        <section class="iv-m-t-32">
          <slot></slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import column from './review-group-column'
import Expand from '@/components/expand-info'
import IconFont from '@/components/iconfont'
import DragTable from '@/components/drag-table-inline'

export default {
  props: {
    tableData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      columns: [],
      dictMap: {}
    }
  },
  async created () {
    this.reviewInfo = {
      title: this.$decode(this.$route.query.title),
      publishOrg: this.$decode(this.$route.query.publishOrg),
      publisher: this.$decode(this.$route.query.publisher)
    }
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    this.type = this.$decode(this.$route.query.type)
    await this.getCodeTable('BOE39')
    await this.getCodeTable('BOE40')
    this.columns = column.call(this)
  },
  methods: {
    getTableData () {
      return this.$refs.DragTable.$refs.Table.rebuildData
    },
    //数据字典
    getCodeTable (code) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length &&  data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    }
  },
  components: {
    Expand,
    IconFont,
    DragTable
  }
}
</script>

<style lang="scss" scoped>
.iv-review-group {
  .iv-review-top {
    background: #F5F7FA;
  }
  .iv-review-content {
    background: #fff;
    /deep/ .ivu-table {
      font-size: 16px;
      font-weight: 400;
      color: rgba($color: #000000, $alpha: 0.65);
      .ivu-checkbox-inner {
        width: 16px;
        height: 16px;
        outline-color: #45BC7D !important;
        &:after {
          top: 50%;
          margin-top: -5px;
          left: 50%;
          margin-left: -2px;
        }
      }
      .ivu-checkbox-checked .ivu-checkbox-inner {
        background: #45BC7D !important;
        border-color: #45BC7D !important;
      }
    }
  }
}
</style>
